import 'whatwg-fetch/dist/fetch.umd.js';
import 'promise-polyfill/dist/polyfill';

/**
 * Calls the API to check if the given email exists in the database
 * @param {String} email - The email to check
 * @returns {Promise<Boolean>} - A fetch promise containing a boolean indicating if the email exists
 */
export function emailExistsAsync(email) {
  const url = `https://${process.env.apiHost}/v1/learn-lab/users/exists?email=${encodeURIComponent(email)}`;
  return fetch(url).then(response => String(response.status).slice(0, 2) === '20');
}

/**
 * Calls the API to create a new user
 * @param {*} data - The data to send
 * @returns {Promise<Object>} - A fetch promise containing the response JSON
 */
export function createUserAsync(data) {
  const url = `https://${process.env.apiHost}/v1/learn-lab/users`;
  return fetch(
    url,
    {
      body: JSON.stringify(data),
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      redirect: 'follow'
    }
  ).then(response => response.json());
}
